import { SET_IMAGE_FOR_UPLOAD } from '../../constants/actions';

const initialState = {
  src: '',
  fromWHere: ''
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_IMAGE_FOR_UPLOAD:
      return {src: action.data.src, fromWhere: action.data.fromWhere};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/imageForUpload.js